<template>
  <div class="telemetry-throttle-pedal-parts">
    <svg
      class="telemetry-throttle-pedal-parts__gauge"
      width="303"
      height="200"
      viewBox="0 0 303 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="telemetry-throttle-pedal-parts__gauge__clip">
        <rect
          width="303"
          :height="gaugeHeight"
          x="0"
          :y="gaugePositionY"
          fill="white"
          opacity="0.8"
        ></rect>
      </clipPath>

      <path
        clip-path="url(#telemetry-throttle-pedal-parts__gauge__clip)"
        opacity="0.5"
        d="M303 24C303 10.7452 292.255 0 279 0H183V2H249C256.732 2 263 8.26801 263 16V150.059C263 156.424 265.529 162.529 270.029 167.029L303 200V24Z"
        fill="#00DBA6"
        fill-opacity="0.7"
      />
      <path
        clip-path="url(#telemetry-throttle-pedal-parts__gauge__clip)"
        d="M303 24C303 10.7452 292.255 0 279 0H183V1H278C290.703 1 301 11.2975 301 24V198L303 200V24Z"
        fill="#00DBA6"
      />
      <g opacity="0.5">
        <path
          d="M303 28C303 12.536 290.464 0 275 0H183V2H249C256.732 2 263 8.26801 263 16V150.059C263 156.424 265.529 162.529 270.029 167.029L303 200V28Z"
          fill="url(#paint0_linear_757_14846)"
        />
        <path
          d="M303 24C303 10.7452 292.255 0 279 0H183V1H278C290.703 1 301 11.2975 301 24V198L303 200V24Z"
          fill="#00DBA6"
        />
      </g>
      <path
        opacity="0.6"
        d="M303 88L290.515 100.485C288.264 102.736 287 105.788 287 108.971V184L303 200V88Z"
        fill="black"
      />
      <defs>
        <linearGradient
          id="paint0_linear_757_14846"
          x1="303"
          y1="0"
          x2="270"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#009B71" />
          <stop offset="1" stop-color="#009B71" stop-opacity="0.3" />
        </linearGradient>
      </defs>
      <text class="telemetry-throttle-pedal-parts__label" x="109" y="-291" transform="rotate(90)">
        THROTTLE
      </text>
    </svg>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import useTelemetrySectionUtil from '@/components/RaceVideoPage/RaceVideoDataViewPane/hook/useTelemetrySectionUtil'

/**
 * レース動画再生画面 テレメトリー アクセルペダル 値セクションのコンポーネント
 */
export default defineComponent({
  name: 'TelemetryThrottlePedalParts',
  components: {},
  props: {
    /**
     * バリュー値
     */
    value: {
      type: Number,
      required: true,
      default: 0,
    },
    /**
     * ゲージMAX値
     */
    max: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  setup(props) {
    const { adjustPosition } = useTelemetrySectionUtil()

    // 位置指定を整数化
    adjustPosition('.telemetry-throttle-pedal-parts')

    // ゲージ高さ
    const gaugeSvgHeight = 200

    /**
     * gaugeHeight
     * ゲージの高さを算出
     */
    const gaugeHeight = computed(() => (gaugeSvgHeight * props.value) / props.max)

    /**
     * gaugePositionY
     * ゲージのY位置を算出
     */
    const gaugePositionY = computed(
      () => gaugeSvgHeight - (gaugeSvgHeight * props.value) / props.max,
    )

    return {
      gaugeHeight,
      gaugePositionY,
    }
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.telemetry-throttle-pedal-parts {
  position: absolute;
  left: calc(#{min(4.2667vw, 1.333em)} + 1.6667em);
  top: calc(#{min(4.2667vw, 1.333em)} + 2em);
  width: 25.25em;
  height: 16.6667em;

  &__gauge {
    position: absolute;
    width: 100%;
    z-index: 1;

    rect {
      transition: all linear $telemetryFps;
    }
  }

  &__label {
    font-weight: 500;
    fill: $green-light;
    font-size: 12px;
  }
}
</style>

<style lang="scss">
.race-telemetry-section {
  &--landscape-primary,
  &--landscape-secondary {
    .telemetry-throttle-pedal-parts {
      top: 2.4em;
    }
  }
}
</style>
